import React from 'react';
import NavBar from './components/NavBar';
import HomePage from './components/HomePage';
import Services from './components/Services';
import AboutUs from './components/AboutUs';
import Footer from './components/Footer';
import CoFounders from './components/CoFounders';
import './App.css';
import hikImage from './images/hik4.jpg';

const foundersData = [
  { name: 'Hikaru Saito', title: 'CEO & Co-Founder', image: hikImage },
];



function App() {
  return (
    <div className="App">
      <NavBar />
      <HomePage />
      <Services />
        <div className="container mx-auto text-center">
            <h2 className="text-4xl font-bold mb-12 text-[#365DC9]">Meet the Co-Founders</h2>
            <CoFounders founders={foundersData} />    
        </div>
      <AboutUs />
      <Footer />
    </div>
  );
}

export default App;